import React from "react";
import { Table as AntdTable } from "antd";
import Pagination from "./Pagination";

const { Column } = AntdTable;

const Table = ({
  loading,
  columns,
  dataSource,
  page,
  pageSize,
  totalItems,
  pagination,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <div>
      <AntdTable showHeader pagination={false} dataSource={dataSource} {...{ loading }}>
        {(columns || []).map(
          (column, index) =>
            typeof column !== "boolean" && (
              <Column key={index} title={column.title} dataIndex={column.dataIndex} render={column.render} />
            ),
        )}
      </AntdTable>
      {pagination && (
        <Pagination
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      )}
    </div>
  );
};

Table.defaultProps = {
  pagination: true,
};

export default Table;
